export function startNumberTicker() {
  document.addEventListener("DOMContentLoaded", function() {
    function handleTicker(element, finalNumber, displayPlus) {
      const isYear = element.getAttribute('data-is-year') === 'true';
      let digits = finalNumber.toString().length;
      let increment;

      if (digits >= 6) {
        increment = 1000;
      } else if (digits === 5) {
        increment = 100;
      } else if (digits >= 4) {
        increment = 100;
      } else {
        increment = 1;
      }

      let startNumber = finalNumber - (10 * increment);
      if (startNumber < 0) {
        startNumber = 0;
      }

      function updateNumber() {
        if (startNumber <= finalNumber) {
          let displayNumber = startNumber;

          if (finalNumber >= 1000 && !isYear) {
            displayNumber = startNumber.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
          }

          element.textContent = displayNumber + (displayPlus ? '+' : '');
          startNumber += increment;
        } else {
          clearInterval(interval);
        }
      }

      const interval = setInterval(updateNumber, 80);
    }

    function handleIntersection(entries, observer) {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const element = entry.target;
          const displayPlus = element.textContent.endsWith('+');
          const cleanedNumber = displayPlus ? element.textContent.slice(0, -1) : element.textContent;
          const finalNumber = parseInt(cleanedNumber.replace(/,/g, '').trim(), 10);
          handleTicker(element, finalNumber, displayPlus);
          observer.unobserve(element);
        }
      });
    }

    const observer = new IntersectionObserver(handleIntersection);
    const numberElements = document.querySelectorAll('.number-ticker__number');
    numberElements.forEach((element) => observer.observe(element));
  });
}
